<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <b>我的笔记</b>
      </div>
      <div class="search">
        <input
          type="text"
          placeholder="请输入搜索关键字"
          class="uc-input"
          v-model="query.keyword"
        />
        <a
          href="javascript:;"
          @click="
            query.pageIndex = 1;
            initData();
          "
          class="uc-btn blue"
          ><i class="uc-font uc-search"></i
        ></a>
      </div>
    </div>

    <section class="uc-userCenterTitleTab3 bg-white">
      <div class="table">
        <table>
          <tr>
            <th style="width:60%;" class="left">课程名称</th>
            <th style="width:15%;">课程进度</th>
            <th style="width:15%;">学习时长</th>
            <th style="width:10%;">导出</th>
          </tr>
          <tr v-if="list.total_count == 0">
            <td colspan="6">
              <div class="content-empty">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
            </td>
          </tr>
          <tr v-for="(item, index) in list.items" :key="index">
            <td class="left">
              <router-link
                :to="{
                  name: 'PersonalMyNoteDetail',
                  params: { id: item.id },
                }"
              >
                {{ item.name }}
              </router-link>
            </td>
            <td class="uc-orange">
              <b>{{ item.browse_percent }}</b>
            </td>
            <td>{{ item.learn_duration }}</td>
            <td>
              <router-link to="">
                <el-tooltip content="导出" placement="top">
                  <i
                    class="el-icon-download uc-ml15"
                    @click="handelExportNotes(item)"
                  ></i>
                </el-tooltip>
              </router-link>
            </td>
          </tr>
        </table>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'PersonalMyNote',
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 10,
        keyword: undefined,
      },
      list: [],
      formLabelWidth: '100px',
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getMyCourses();
    },
    async getMyCourses() {
      const response = await this.$api.course.getMyCourses(this.query);
      this.list = response.data.data;
    },
    handelExportNotes(item) {
      const submitData = {
        cid: item.id,
        name: item.name,
      };
      this.$api.course.postExportCourseNote(submitData).then((res) => {
        // 处理返回的文件流

        //主要是将返回的data数据通过blob保存成文件

        var content = res.data;

        var blob = new Blob([content]);

        var fileName = item.name + '课程_导出笔记.xlsx'; //要保存的文件名称

        if ('download' in document.createElement('a')) {
          // 非IE下载
          var elink = document.createElement('a');

          elink.download = fileName;

          elink.style.display = 'none';

          elink.href = URL.createObjectURL(blob);

          document.body.appendChild(elink);

          elink.click();

          URL.revokeObjectURL(elink.href); // 释放URL 对象

          document.body.removeChild(elink);
        } else {
          // IE10+下载

          navigator.msSaveBlob(blob, fileName);
        }

        console.log(res);
      });
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.initData();
    },
  },
};
</script>
